import React from 'react';

import Console from '../../lib/debug';

const GroupIcon = props => {
    Console.render('GroupIcon');
    return <img alt="" src={props.src} className="group-icon" />;
};

export default GroupIcon;



// WEBPACK FOOTER //
// ./src/view/common/GroupIcon.jsx